const isConsentCollected = async () => {
  return new Promise((resolve, reject) => {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          console.error('Error loading features:', error);
        }
        const analytics = window.Shopify.customerPrivacy.analyticsProcessingAllowed()
        const marketing = window.Shopify.customerPrivacy.marketingAllowed();
        resolve(analytics && marketing);
      },
    );
  });
};

const initSklikScript = async () => {
  return new Promise((resolve, reject) => {
    console.log('Initializing Sklik script...');

    const script = document.createElement('script');
    script.setAttribute('src', 'https://c.seznam.cz/js/rc.js');
    script.setAttribute('async', '');
    
    script.onload = () => {
      console.log('Sklik script loaded successfully');
      resolve();
    };
    
    script.onerror = (error) => {
      console.error('Failed to load Sklik script:', error);
      reject(error);
    };
    
    document.head.appendChild(script);
  });
};

(async () => {
  try {
    const consentCollected = await isConsentCollected();
    if (!consentCollected) {
      console.log('Consent not collected');
      return;
    }

    await initSklikScript();

    const isSklikScriptLoaded = window.sznIVA && window.rc;
    if (isSklikScriptLoaded) {
      var retargetingConf = {
        rtgId: 1587737,
        consent: 1
      };
      window.rc.retargetingHit(retargetingConf);

      console.log('Sklik hit sent');
    } else {
      console.log('Sklik objects not available yet');
    }
  } catch (error) {
    console.error('Error processing Sklik event:', error);
  }
})();
